module.exports = __webpack_public_path__ + "static/worldhemophiliaday-860159bd9f5f2be0343aeef7118db033.png";